import { BookModel } from "@/types/book";
import { action, makeObservable, observable } from "mobx";
import { getUserDraftList, getUserPublishedList } from "../requests/book";

class AdminIndex {
    // 草稿列表
    public draftList: Array<BookModel> = [];
    // 已发布列表
    public publishedList: Array<BookModel> = [];
    constructor() {
        makeObservable(this, {
            draftList: observable,
            publishedList: observable,
            fetchDraftList: action,
            fetchPublishedList: action,
        })
    }
    public async fetchDraftList() {
        const res = await getUserDraftList();
        if (res) {
            this.draftList = res;
        }
    }
    public async fetchPublishedList() {
        const res = await getUserPublishedList();
        console.log("书", res);
        if (res) {
            this.publishedList = res;
        }
    }
}

const adminIndex = new AdminIndex();

export default adminIndex;